import {ChangeDetectorRef} from "@angular/core";

export class SafeChangeDetectorRef extends ChangeDetectorRef {
    private wrapped: ChangeDetectorRef;

    constructor(wrapped: ChangeDetectorRef) {
        super();
        this.wrapped = wrapped;
    }

    detectChanges(): void {
        if (!(<any>this.wrapped).destroyed) {
            this.wrapped.detectChanges();
        }
    }

    checkNoChanges(): void {
        if (!(<any>this.wrapped).destroyed) {
            this.wrapped.checkNoChanges();
        }
    }

    detach(): void {
        if (!(<any>this.wrapped).destroyed) {
            this.wrapped.detach();
        }
    }

    markForCheck(): void {
        if (!(<any>this.wrapped).destroyed) {
            this.wrapped.markForCheck();
        }
    }

    reattach(): void {
        if (!(<any>this.wrapped).destroyed) {
            this.wrapped.reattach();
        }
    }
}
